import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropDown } from '../../models/dropdown';
import { debounceTime, distinctUntilChanged, EMPTY, filter, switchMap, tap } from 'rxjs';
import { RpoToolService } from '../../services/rpo-tool.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as constants from 'src/app/config/app-constants';
import { DeviceResponse, DrugDataResponse, UpdateDrug } from '../../models/drug';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { QuarantineStateService } from 'src/app/shared/services/quarantine-state.service';


@Component({
    selector: 'app-merge-quarantine-drug-wizard',
    templateUrl: './merge-quarantine-drug-wizard.component.html',
    styleUrls: ['./merge-quarantine-drug-wizard.component.scss'],
    standalone: false
})
export class MergeQuarantineDrugWizardComponent implements OnInit {

  alertWizardTitle: string;
  titelFontColor: string;
  bodyMessageColor: string;
  cancelButtonText: string;
  confirmButtonText: string;
  cancelButtonColor: string;
  confirmButtonColor: string;
  buttonglobalClass: string;
  isButtonOneDisabled: boolean;
  isButtonTwoDisabled: boolean;
  isLoading: boolean = false;

  quarantineReason: string;
  quarantineDrugNumber: string

  drugName: FormControl;
  drugNameId: number;
  listOfDrugName: DropDown[] = [] as DropDown[]

  strength: FormControl;
  unit: FormControl;
  unitId: number;
  cddbUnitId: number;

  saveQuarantineDrugFormModal: FormGroup;

  suggestionList: any[] = []; // Combined suggestions
  displayedColumns: string[] = ['drugName', 'strength', 'unit'];

  isPermanentQuarantine = false;

  drugUpdateModel: UpdateDrug;

  quarantineDrugAllInfo: DrugDataResponse
  maxDeviceInfo: DeviceResponse
  synmedDeviceInfo: DeviceResponse
  atpDeviceInfo: DeviceResponse
  passDeviceInfo: DeviceResponse

  selectedSuggestionIndex: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<MergeQuarantineDrugWizardComponent>,
    public dialog: MatDialog,
    private rpoToolService: RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private quarantineStateService: QuarantineStateService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.alertWizardTitle = data.title;
    this.cancelButtonText = data.cancelBtnText;
    this.confirmButtonText = data.confirmBtnText;
    this.strength = new FormControl(data.strength || '');
    this.drugName = new FormControl(data.drugName || '');
    this.unit = new FormControl(data.unit || '');
    this.quarantineReason = data.quarantineReason
    this.quarantineDrugNumber = data.quarantineDrugNumber
    this.quarantineDrugAllInfo = data.drugAllInfo
    this.maxDeviceInfo = this.quarantineDrugAllInfo.devices.filter((eachDevice) => eachDevice.deviceName === "MAX")[0]
    this.atpDeviceInfo = this.quarantineDrugAllInfo.devices.filter((eachDevice) => eachDevice.deviceName === "ATP")[0]
    this.synmedDeviceInfo = this.quarantineDrugAllInfo.devices.filter((eachDevice) => eachDevice.deviceName === "SYNMED")[0]
    this.passDeviceInfo = this.quarantineDrugAllInfo.devices.filter((eachDevice) => eachDevice.deviceName === "PASS")[0]



    this.cancelButtonColor =
      data.cancelButtonColor == undefined
        ? "btn-light-blue"
        : data.cancelButtonColor;
    this.confirmButtonColor =
      data.confirmButtonColor == undefined
        ? "btn-light-red"
        : data.confirmButtonColor;
    this.buttonglobalClass = data.buttonglobalClass == undefined ? "end end" : data.buttonglobalClass;
    this.isButtonOneDisabled = data.isButtonOneDisabled == undefined ? false : data.isButtonOneDisabled;
    this.isButtonTwoDisabled = data.isButtonTwoDisabled == undefined ? false : data.isButtonTwoDisabled;
  }

  ngOnInit(): void {
    this.saveQuarantineDrugFormModal = new FormGroup({
      drugName: this.drugName,
      strength: this.strength,
      unit: this.unit,
      reason: new FormControl()
    })

    this.updateSuggestions(this.data.drugName, this.quarantineDrugNumber, this.quarantineReason)


    this.drugName.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(value => value && !Number.isFinite(value))
      )
      .subscribe(searchTerm => {
        setTimeout(() => {
          if (searchTerm && searchTerm.length > 2) {
            this.isLoading = true;
            this.getDrugName(searchTerm);
          }
          else {
            this.listOfDrugName = [];
          }
          this.isLoading = false;
        }, 400);
      });

    if (this.drugName.value && !Number.isFinite(this.drugName.value)) {
      this.getDrugName(this.drugName.value);
    }

  }

  onDrugNameInput() {
    const name = this.drugName.value;
    if (name && name.length > 2) {
      this.isLoading = true;
      this.rpoToolService.getDrugName(name).subscribe(
        (result) => {
          this.listOfDrugName = result.data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(
            error.error.message === undefined ? 'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
    }
  }

  updateSuggestions(quarantineDrugName: string, quarantineDrugNumber: string, qReason: string) {
    // This is where you would typically make an API call to get suggestions
    this.ngxLoader.start();
    this.rpoToolService.getDrugNameStrengthAndUnitByNameAndDrugNumber(
      quarantineDrugName,
      quarantineDrugNumber,
      qReason,
    ).subscribe((response) => {
      this.suggestionList = response.data;

      this.ngxLoader.stop();
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop();
        this.toastService.openToast(error.error.message??
          error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }


  onSuggestionRowSelect(element: any, index: number) {
    this.selectedSuggestionIndex = index;
    // Set the drug name based on the selection
    if (this.showDrugName()) {
      this.drugName.setValue(element.drugName);
      this.drugNameId = element.drugNameId
    }
    if (this.showStrengthAndUnit()) {
      // Set the strength based on the selection
      this.strength.setValue(element.strength);

      // Set the unit based on the selection
      this.unit.setValue(element.unitDescription);
      this.unitId = element.unitId
      this.cddbUnitId = element.cddbUnitId
    }
  }


  showDrugName(): boolean {
    const val = this.quarantineReason;
    return val === "Drug Name, Strength and UofM Mismatch" || val === "Drug Name Mismatch";
  }

  showStrengthAndUnit(): boolean {
    const val = this.quarantineReason;
    return val === "Strength or UofM Mismatch" || val === "Drug Name, Strength and UofM Mismatch";
  }

  displayFnDrugName(value?: any) {
    return value;
  }


  isRowDisabled(element: any): boolean {
    const quarantineDrugNumber = this.quarantineDrugNumber;
    const rowDrugNumber = element.drugNumber;

    // Check if both the quarantined and row drug numbers exist and if first 9 digits match
    if (quarantineDrugNumber && rowDrugNumber) {
      const quarantinedDrugFirstNine = quarantineDrugNumber.substring(0, 9);
      const rowDrugNumberFirstNine = rowDrugNumber.substring(0, 9);

      // If first 9 digits don't match, disable the row
      if (quarantinedDrugFirstNine !== rowDrugNumberFirstNine && this.quarantineReason !== "Drug Name, Strength and UofM Mismatch") {
        return true;
      }
    }

    return false;
  }

  getDisplayedColumnsWithRadio(): string[] {
    const cols = ['select', 'drugNumber', 'drugName', 'genericName', 'strength', 'unit', 'source', 'mfg'];
    return cols;
  }

  getDrugName(search) {
    if (search?.length == 0) {
      return;
    }
    this.isLoading = true;
    this.rpoToolService
      .getDrugName(search)
      .subscribe(
        (result) => {
          this.listOfDrugName = result.data;
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.toastService.openToast(error.error.message === undefined ?
            'Something went wrong!!' : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }




  onPermanentQuarantineChange(event: any) {
    console.log(event.value, "isPermanentQuarantine");

    this.isPermanentQuarantine = event.value === 'yes';

    if (this.isPermanentQuarantine) {
      this.saveQuarantineDrugFormModal.get('reason')?.setValue('Permanent Quarantine');
    } else {
      this.saveQuarantineDrugFormModal.get('reason')?.setValue(''); // or reset to previous value if needed
    }
  }


disableQuarantineDrugSubmitBtn() {
    console.log(this.saveQuarantineDrugFormModal.get('reason').value);

    const reason = this.saveQuarantineDrugFormModal.get('reason').value !== null;
    const drugName = this.saveQuarantineDrugFormModal.get('drugName').value;
    const strength = this.saveQuarantineDrugFormModal.get('strength').value;
    const unit = this.saveQuarantineDrugFormModal.get('unit').value;

    // If drug name mismatch - check drugName and reason are present
    if (this.quarantineReason === 'Drug Name Mismatch') {
        return !drugName || !reason;
    }

    // If drug name strength unit mismatch - check if drugName, strength, unit and reason are present
    if (this.quarantineReason === "Drug Name, Strength and UofM Mismatch") {
        return (!drugName || !strength || !unit) || !reason;
    }

    // If strength, unit mismatch - check if strength, unit and reason are present
    if (this.quarantineReason === 'Strength or UofM Mismatch') {
        return (!strength || !unit) || !reason;
    }
}


  clearFormData() {
    this.saveQuarantineDrugFormModal.reset();
    this.closeDialog(true);
  }

  closeDialog(response: boolean) {
    this.dialogRef.close({ event: 'close', data: response })
  }



  checkQuarantineDrugAlreadyResolvedOrNotBasedOnDnumber(dnumber: string) {
    return this.rpoToolService.checkQuarantineDrugAlreadyResolved(dnumber).pipe(
      tap((response) => {
        let result = response.data;
        console.log(result, "checkQuarantineDrugAlreadyResolvedOrNotBasedOnDnumber");

        // Update the service which will notify the parent component
        this.quarantineStateService.updateQuarantineStatus(result ? true : false);
      })
    );
  }


  updateDrug() {
    console.log(this.saveQuarantineDrugFormModal?.valid, "this.saveQuarantineDrugFormModal?.valid");

    if (!this.saveQuarantineDrugFormModal?.valid)
      return;

    this.drugInforUpdateApi()
  }

  drugInforUpdateApi() {
    const formValue = this.saveQuarantineDrugFormModal.value;
    this.drugUpdateModel = {
      classificationShapeId: this.quarantineDrugAllInfo.characteristics.classificationShapeId,
      length: this.quarantineDrugAllInfo.characteristics.length,
      dnumber: this.quarantineDrugAllInfo.characteristics.dnumber && this.quarantineDrugAllInfo.characteristics.dnumber.split("D")[1],
      width: this.quarantineDrugAllInfo.characteristics.width,
      thickness: this.quarantineDrugAllInfo.characteristics.thickness,
      ridgeThickness: this.quarantineDrugAllInfo.characteristics.ridgeThickness,
      weight: this.quarantineDrugAllInfo.characteristics.weight,
      diagonal: this.quarantineDrugAllInfo.characteristics.diagonal,
      ndc: this.quarantineDrugAllInfo.characteristics.drugId,
      packageBarcode: this.quarantineDrugAllInfo.characteristics.barcode,
      packageBarcode2d: this.quarantineDrugAllInfo.characteristics.barcode2d,
      packageThirtyDramCapacity: this.quarantineDrugAllInfo.characteristics.thirtyDramCapacity,
      coatingId: this.quarantineDrugAllInfo.characteristics.coatingId && this.quarantineDrugAllInfo.characteristics.coatingId.toString(),
      packageImprint1: this.quarantineDrugAllInfo.characteristics.imprint1,
      packageImprint2: this.quarantineDrugAllInfo.characteristics.imprint2,
      color: this.quarantineDrugAllInfo.characteristics.color !== "||"
        ? this.quarantineDrugAllInfo.characteristics.color.includes("||")
          ? this.quarantineDrugAllInfo.characteristics.color.split("||")[1] // taking the CDDB Color
          : this.quarantineDrugAllInfo.characteristics.color
        : "",
      scoringId: this.quarantineDrugAllInfo.characteristics.scoringId,

      maxThirtyDramDnu: parseInt(this.maxDeviceInfo.thirtyDramDnu),
      maxDoNotUse: this.maxDeviceInfo.doNotUse,
      maxDrugStatus: this.maxDeviceInfo.maxDrugStatus,
      maxCellHeight: this.maxDeviceInfo.cellHeight,
      maxCellWidth: this.maxDeviceInfo.cellWidth,
      maxBaffle: this.maxDeviceInfo.baffle,
      maxPressure: parseInt(this.maxDeviceInfo.pressure),

      atpDrugStatus: this.atpDeviceInfo.atpDrugStatus,
      atpTcgDiameter: this.atpDeviceInfo.atpTcgDiameter,
      atpTcgPillType: this.atpDeviceInfo.tcgPillType,
      atpTcgPillVolume: parseInt(this.atpDeviceInfo.tcgPillVolume),
      atpTcgT1: parseInt(this.atpDeviceInfo.tcgT1),
      atpTcgT2: parseInt(this.atpDeviceInfo.tcgT2),
      atpCanisterNumber: this.atpDeviceInfo.canisterNumber,
      atpLabOptimized: this.atpDeviceInfo.labOptimized,


      synMedPnr: this.synmedDeviceInfo.dnuReason,
      synmedIsLabOptimized: this.synmedDeviceInfo.labOptimized,
      passIsLabOptimized: this.passDeviceInfo.labOptimized,
      maxIsLabOptimized: this.maxDeviceInfo.labOptimized,
      atpIsLabOptimized: this.atpDeviceInfo.labOptimized,
      passDrugStatus: this.passDeviceInfo.passDrugStatus,
      passCanisterNumber: this.passDeviceInfo.canisterId,
      passSnapCanisterNumber: this.passDeviceInfo.snapCanisterId,

      massIndex: this.synmedDeviceInfo.massIndex,
      lidHoleSize: this.synmedDeviceInfo.lidHoleSize,
      lidVolcanic: this.synmedDeviceInfo.lidVolcanic,
      fragileFlag: this.synmedDeviceInfo.fragileFlag,
      toggleFlag: this.synmedDeviceInfo.toggleFlag,
      pipetteSize: this.synmedDeviceInfo.pipetteSize,

      source: this.quarantineDrugAllInfo.characteristics.source,
      id: this.quarantineDrugAllInfo.characteristics.id,
      schemaName: this.quarantineDrugAllInfo.characteristics.schemaName,
      distributorId: this.quarantineDrugAllInfo.characteristics.distributorId,
      packageSize: this.quarantineDrugAllInfo.characteristics.packageSize,
      packageDepth: this.quarantineDrugAllInfo.characteristics.packageDepth,
      packageHeight: this.quarantineDrugAllInfo.characteristics.packageHeight,

      packageTypeId: this.quarantineDrugAllInfo.characteristics.packageTypeId,
      packageWidth: this.quarantineDrugAllInfo.characteristics.packageWidth,
      countryCodeId: this.quarantineDrugAllInfo.characteristics.countryCodeId && this.quarantineDrugAllInfo.characteristics.countryCodeId.toString(),
      drugNumberTypeId: this.quarantineDrugAllInfo.characteristics.drugNumberTypeId && this.quarantineDrugAllInfo.characteristics.drugNumberTypeId.toString(),
      oralSolid: this.quarantineDrugAllInfo.characteristics.oralSolid,
      synmedDrugStatus: this.synmedDeviceInfo.synmedDrugStatus,
      cellCapacity: this.atpDeviceInfo.cellCapacity,
      superCellCapacity: this.atpDeviceInfo.superCellCapacity,
      canisterCapacity: parseInt(this.atpDeviceInfo.canisterCapacity),
      highCapCapacity: parseInt(this.atpDeviceInfo.highCapCapacity),

      // q_reason as either "Permanent Quarantine" or "Removed From Quarantine"
      quarantineId: this.isPermanentQuarantine ? "6" : "7",

      shapeId: this.quarantineDrugAllInfo.characteristics.shapeId,

      nonCountReasonId: this.passDeviceInfo.nonCountReasonId,
      largePipetteDropHeight: parseInt(this.synmedDeviceInfo.largePipetteDropHeight),
      smallPipetteDropHeight: parseInt(this.synmedDeviceInfo.smallPipetteDropHeight),
      preferredLidHoleSize: parseInt(this.synmedDeviceInfo.preferredLidHoleSize),
      preferredContainerSize: this.synmedDeviceInfo.preferredContainerSize,
      preferredPipetteSize: this.synmedDeviceInfo.preferredPipetteSize,
      smallCanisterCapacity: this.synmedDeviceInfo.smallCanisterCapacity,
      largeCanisterCapacity: this.synmedDeviceInfo.largeCanisterCapacity,

      //characteristics
      genericName: this.quarantineDrugAllInfo.characteristics.genericName,

      // Modify with master source data
      strength: formValue.strength,
      unitId: this.showStrengthAndUnit() ? this.cddbUnitId : this.quarantineDrugAllInfo.characteristics.unitId,
      strengthUnitId: this.showStrengthAndUnit() ? this.unitId: null,

      drugId: this.quarantineDrugAllInfo.characteristics.drugId,
      active: this.quarantineDrugAllInfo.characteristics.active,
      scheduleId: this.quarantineDrugAllInfo.characteristics.scheduleId,
      manufacturer: this.quarantineDrugAllInfo.characteristics.manufacturer,
      routeOfAdminId: this.quarantineDrugAllInfo.characteristics.routeOfAdminId,
      dosageFormId: this.quarantineDrugAllInfo.characteristics.dosageFormId,
      otc: this.quarantineDrugAllInfo.characteristics.otc,
      dosageForm: this.quarantineDrugAllInfo.characteristics.dosageForm,
      niosh: this.quarantineDrugAllInfo.characteristics.niosh,
      antibiotics: this.quarantineDrugAllInfo.characteristics.antibiotics,
      unitOfUse: this.quarantineDrugAllInfo.characteristics.unitOfUse,
      unitDose: this.quarantineDrugAllInfo.characteristics.unitDose,
      updated: this.quarantineDrugAllInfo.characteristics.updated,
      storageConditions: this.quarantineDrugAllInfo.characteristics.storageConditions,
      gpi: this.quarantineDrugAllInfo.characteristics.gpi,
      gcn: this.quarantineDrugAllInfo.characteristics.gcn,
      shape: this.quarantineDrugAllInfo.characteristics.shape,

      // Modify with master source data
      drugName: formValue.drugName,
      drugNameId: this.drugNameId ? this.drugNameId : this.quarantineDrugAllInfo.characteristics.drugNameId,

      manufacturerId: this.quarantineDrugAllInfo.characteristics.manufacturerId,

      drugStatusId: this.quarantineDrugAllInfo.characteristics.drugStatusId,
      otcId: this.quarantineDrugAllInfo.characteristics.otcId,
      isSuperCellOnly: this.maxDeviceInfo.isSuperCellOnly,
      drugNumberFormatId: this.quarantineDrugAllInfo.characteristics.drugNumberFormatId.toString(),
      gtin: this.quarantineDrugAllInfo.characteristics.gtin,
    };
    this.ngxLoader.start();

    this.rpoToolService
      .updateDrug(this.drugUpdateModel)
      .pipe(
        switchMap((result) => {
          this.ngxLoader.stop();
          if (result.statusCode === 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );

            // Call the second service to resolve quarantine drug only on success (This will add alternate id in resolve_merge_quarantine table)
            const dnumber = this.quarantineDrugAllInfo.characteristics.dnumber
              ? this.quarantineDrugAllInfo.characteristics.dnumber.split('D')[1]
              : null
            const quarantineDrugModel = {
              alternateId: parseInt(dnumber)
            }
            return this.rpoToolService.resolveMergeQuarantine(quarantineDrugModel);
          } else {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
            // Return empty observable to stop the chain
            return EMPTY;
          }
        }),
        switchMap((quarantineResult) => {
          // Handle result from resolveMergeQuarantine
          console.log('Quarantine resolved:', quarantineResult);

          // Check if quarantine was resolved successfully and call the next handler
          if (quarantineResult && quarantineResult.statusCode === 200) {
            const dnumber = this.quarantineDrugAllInfo.characteristics.dnumber
              ? this.quarantineDrugAllInfo.characteristics.dnumber.split('D')[1]
              : null;

            // Call the check method and return its observable
            return this.checkQuarantineDrugAlreadyResolvedOrNotBasedOnDnumber(dnumber);
          } else {
            // If quarantine resolution failed, return empty observable
            return EMPTY;
          }
        })
      )
      .subscribe(
        (quarantineResult) => {
          // Handle result from resolveMergeQuarantine
          console.log('Quarantine resolved:', quarantineResult);
          setTimeout(() => {
            this.clearFormData();
          }, 500);
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop();
          console.log(error);
          this.toastService.openToast(
            error.error.message === undefined
              ? 'Something went wrong!!'
              : error.error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

}
